import { atom } from 'jotai';

export type VolumeDiscountDialogState = 'volume-discount' | 'offer-calculator' | undefined;

/** Which volume-discount dialog (if any) is open. Shared by every VolumeDiscountActivator on a
 * page and owned by the single VolumeDiscountDialogs instance that renders them — so multiple
 * activators (e.g. ADP's price-area link and its shipping/exchange USP button) open the same
 * dialog instead of each mounting its own. Scoped per product/appearance via PdpJotaiProvider. */
export const volumeDiscountOpenDialogAtom = atom<VolumeDiscountDialogState>(undefined);
